/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, Stack, Typography, } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';

import { useTranslation } from 'react-i18next';
import { CheckCircle, KeyboardArrowDown,} from '@mui/icons-material';
import { IRequestGuiModel } from '../../../model/IRequestGuiModel';

const DialogDocumentApproverFlow = ({ approvalFlow }: { isSmAndUpScreen: boolean, approvalFlow: IRequestGuiModel[] }): JSX.Element => {

    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const ArrowDirection = () => {
        return <KeyboardArrowDown fontSize="large" color="info" />   
    }
    return <Grid container component={Paper} direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
            border: 1,
            borderColor: theme.palette.secondary.main,
            backgroundColor: theme.palette.grey[300],
        }}>
        <Grid display="flex" justifyContent="center"
            sx={{
                //borderBottom: 1,
                //borderColor: theme.palette.secondary.main,
                marginBottom: theme.spacing(2),
            }}>
            <Typography variant="h6" color={theme.palette.secondary.main} >{t("approver.flow")}</Typography>
        </Grid>
        <Grid width="100%">
            <Stack alignItems="center"
                direction="column"
                sx={{ width:"100%", maxHeight: "18.5rem", overlowX: "hidden", overflowY: "scroll" }}>
                {approvalFlow.map(d =>
                    <>
                        <Paper
                            sx={{
                                minWidth: "10rem",
                                maxWidth: "12rem",
                                padding: theme.spacing(2),
                                margin: theme.spacing(2),
                                bgcolor: theme.palette.grey[100],
                            }}>
                            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                {d.userFullName}
                            </Typography>
                            <Typography sx={{ fontSize: 14 }}>
                                {d.finished ? new Date(d.finished).toLocaleDateString("nb-NO") + " " + new Date(d.finished).toLocaleTimeString("nb-NO").substring(0, 5) : ""}
                            </Typography>
                        </Paper>
                        <ArrowDirection />
                    </>
                )}
                <CheckCircle fontSize="large" />
            </Stack>
        </Grid>
    </Grid>
}

export default DialogDocumentApproverFlow;